import React from "react";
import SelectSearch from "react-select-search";
import "./SelectSearchBootstrap.scss";

const SelectSearchBootstrap = React.forwardRef((props, ref) => {
  return <SelectSearch ref={ref} {...props} />;
});

export default SelectSearchBootstrap;
